<!-- 登录 -->
<template>
  <div class="user-operation__login">
    <h1 class="user-operation__title">
      <span>登录</span>
    </h1>
    <el-form label-width="0" :model="loginFormModel" :rules="rules" ref="loginForm" class="user-operation__login-form">
      <el-form-item prop="cellphone" ref="cellphone">
        <el-input type="tel" placeholder="请输入手机号" v-model="loginFormModel.cellphone" :maxlength="11"   @change="allowSendingVerifyCode"></el-input>
      </el-form-item>
      <div v-if="!isSmsCodeLogin">
      <el-form-item class="loginPw" prop="loginPassword">
        <el-input type="password" placeholder="请输入密码" v-model="loginFormModel.loginPassword" :maxlength="16" @blur="inputBlurFn('loginPassword')"></el-input>
      </el-form-item>
      <el-form-item class="verification-code" prop="verificationCode">
        <el-input placeholder="请输入验证码" :maxlength="4" v-model="loginFormModel.verificationCode" @keyup.enter.native="submitForm"></el-input>
        <img :src="verificationImageSrc" alt="verification code" ref="verificationCode" v-show="verificationImageSrc" @click="refreshVerificationCode">
      </el-form-item>
      </div>
      <el-form-item v-if="isSmsCodeLogin" class="user-operation__sms-validate-code" prop="SMSVerifyCode">
        <el-input placeholder="请输入短信验证码" v-model="loginFormModel.SMSVerifyCode"
                  :disabled="isAllowSendingVerifyCode" :maxlength="6" @blur="inputBlurFn('SMSVerifyCode')"></el-input>
        <el-button type="primary" size="mini" class="user-operation__sms-button"
                   :disabled="SMSVerificationCodeBtn.disabled" :loading="isLoadingSMSVerifyCode"
                   @click="getSMSVerificationCode">{{SMSVerificationCodeBtn.text}}
        </el-button>
      </el-form-item>
      <el-form-item class="user-operation__login-bottom">
        <div class="user-operation__login-links">
          <span class="user-operation__login-span" @click="changeLoginType">{{loginType}}</span>
          <span>|</span>
          <router-link exact to="/forgetPassword" v-if="!isSmsCodeLogin">忘记密码</router-link>
          <span v-if="!isSmsCodeLogin">|</span>
          <router-link exact to="/register">注册</router-link>
        </div>
        <el-button type="primary" :loading="isLogging" class="user-operation__login-submit" @click.enter="submitForm">登录</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
  import userApi from '../../api/user/user';
  import placeholders from '../../scripts/placeholders';
  import { mapGetters, mapActions } from 'vuex';
  import * as types from '../../vuex/types/type';
  import config from '../../config';
  import messageApi from '../../api/personalCenter/message';

  export default {
    data () {
      const assignValidator = (type, trigger = 'blur') => Object.assign({
        required: true,
        trigger
      }, {
        validator: (rules, value, callback, source, options) => {
          this.$store.dispatch(type, {rules, value, callback, source, options});
        }
      });
      return {
        loginType:"密码登录",
        isSmsCodeLogin:true,
        isAllowSendingVerifyCode: true,
        isLoadingSMSVerifyCode: false,
        isCounting: false,
        SMSVerificationCodeBtn: {
          disabled: true,
          text: '获取验证码'
        },
        isLogging: false,
        publicKey: 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDIfTUBlBteLLCYh0f/j+065J0osV0LF0tS14WC5JEtQUaSrlYaAeV0ws9PfYNrDppPynsKkrhdmueFZCZmshIN1gc/hVz0n+D3AjfD6wHcmx/Vzgy2iTFs9+XoDOiS2TYnKk5VJ8DjdftsfsbQOCEAEqgFneJAeSJ2gTd1CdyZqQIDAQAB',
        verificationImageSrc: '',
        rules: {
           SMSVerifyCode: [{
            required: true,
            trigger: 'blur',
            message: '请填写收到的短信验证码'
          }],
          cellphone: [assignValidator(types.VERIFY_CELLPHONE)],
          loginPassword: [assignValidator(types.VERIFY_LOGIN_PASSWORD)],
          verificationCode: [{
            required: true,
            trigger: 'blur',
            validator: (rules, value, callback, source, options) => {
              this.$store.dispatch(types.VERIFY_LOGIN_VERIFICATION_CODE, {rules, value, callback, source, options}).then((res) => {
                if (res) {
                  if (Number(res.data.code) === 1) {
                    this.refreshVerificationCode();
                  }
                } else {
                  this.refreshVerificationCode();
                }
              });
            }
          }]
        },
        loginFormModel: {
          loginPassword: '',
          SMSVerifyCode:'',
          cellphone: '',
          verificationCode: ''
        }
      };
    },
    computed: {
      ...mapGetters({
        ajaxBaseUrl: types.GET_AJAX_BASE_URL,
        companyInfo: types.GET_COMPANY_INFO
      })
    },
    methods: {
      ...mapActions({
        userLogin: types.USER_LOGIN,
        setAlertMessage: types.SET_FAIL_MESSAGE
      }),
      changeLoginType(){
         this.isSmsCodeLogin=!this.isSmsCodeLogin;
         if(this.isSmsCodeLogin==true){
           this.loginType="密码登录";
         }else{
           this.loginType="短信验证码登录";
         }
      },
       allowSendingVerifyCode (val) {
        if (this.isCounting === false) {
          this.isAllowSendingVerifyCode = val.trim() !== ''
          this.SMSVerificationCodeBtn = {
            disabled: val.trim() === '',
            text: '获取验证码'
          }
        }
      },
       getSMSVerificationCode () {
        this.isLoadingSMSVerifyCode = true
        this.$refs.loginForm.validateField('cellphone')
        if (this.$refs.cellphone.validateState !== 'error') {
          userApi.getSMSVerificationCode({
            mobile: this.loginFormModel.cellphone,
            isForRegister: false
          }).then((res) => {
            this.isAllowSendingVerifyCode = false;
            const resData = res.data;
            let countDownTime = 60;
            if (Number(resData.code) === 0) {
              this.countDown = setInterval(() => {
                this.isLoadingSMSVerifyCode = false;
                this.isCounting = true;
                countDownTime -= 1;
                if (countDownTime !== 0) {
                  this.SMSVerificationCodeBtn = {
                    disabled: true,
                    text: `${countDownTime}秒后获取`
                  };
                } else {
                  this.SMSVerificationCodeBtn = {
                    disabled: false,
                    text: '获取验证码'
                  };
                  clearInterval(this.countDown);
                  this.isCounting = false;
                }
              }, 1000);
            } else {
              this.isLoadingSMSVerifyCode = false;
              this.setAlertMessage({
                show: true,
                content: resData.result
              });
            }
          }).catch((error) => {
            if (error) {
              this.isLoadingSMSVerifyCode = false
            } else {
              this.isLoadingSMSVerifyCode = false
            }
          })
        } else {
          this.isLoadingSMSVerifyCode = false
          this.SMSVerificationCodeBtn = {
            disabled: true,
            text: '获取验证码'
          }
        }
      },
      refreshVerificationCode () {
        this.verificationImageSrc = `${config.ajaxBaseUrl}/servlet/ValidCode?rand=${new Date().getTime()}`;
      },
      getunread () {
        messageApi.unRead({
          tokenId: localStorage.getItem('dl_tokenId_bl')
        }).then((res) => {
          if (res.code === 0) {
            this.$store.commit('changeState', res.result);
            this.result = res.result;
          } else {
          }
        }).catch((err) => {
        });
      },
      submitForm () {
        this.$refs.loginForm.validate((valid) => {
          if (valid) {
            const form = this.loginFormModel;
            this.isLogging = true;
            const encrypt = new JSEncrypt();
            encrypt.setPublicKey(this.publicKey);
            const _loginPassword = encodeURI(encrypt.encrypt(form.loginPassword));
            this.userLogin({
              loginName: form.cellphone,
              password: _loginPassword,
              smsCode:form.SMSVerifyCode,
              isSmsLogin:this.isSmsCodeLogin==true?true:false
            }).then((res) => {
              this.isLogging = false;
              if (Number(res.data.code) === 0) {
                localStorage.setItem('dl_tokenId_bl', res.data.data.token);
                this.getunread();
                this.$router.push('/personalCenter/myLoan_bl/loanLists_bl');
                location.reload();
              } else {
                this.refreshVerificationCode();
              }
            });
          } else {
            setTimeout(() => {
              placeholders.placeHolder(this);
            }, 30);
            return false;
          }
        });
      },
      inputBlurFn (prop) {
        if (event.srcElement) {
          this.loginFormModel[prop] = event.srcElement.value;
        }
      },
    },

  created () {
      this.$store.state[0].msgNum == 0;
    },

  mounted () {
      this.refreshVerificationCode();
    }
  };
</script>
<style lang="scss">
  .user-operation__login {
    @include userOperationBlockStyle;
  }
  .user-operation__title {
    @include clear;
    margin-bottom: 20px;

    & img {
      float: left;
      line-height: 40px;
      font-size: 14px;
      height: 40px;
    }

    & span {
      float: left;
      margin-left: 16px;
      line-height: 40px;
      font-family: 'MyriadPro-Regular';
      font-size: 20px;
      color: #999;
    }
  }

  .user-operation__login-form {
    @include userOperationFormStyle;
  }

  .user-operation__login-bottom {
    margin-bottom: 0;
  }

  .user-operation__login-span{
     cursor: pointer;
  }

  .user-operation__login-links {
    float: left;
    position: absolute;
    bottom: 0;
    color: $orange;
    font-family: 'FZLanTingHei-DB-GBK';
    font-size: 12px;
    line-height: 1;

    & a {
      color: $orange;
    }
  }

  .user-operation__login-submit {
    float: right;
    border: 1px solid $orange;
    width: 120px;
    height: 45px;
    font-size: 14px;
    background: $orange;

    &:hover, &:focus, &:active {
      border: 1px solid $orange;
      background: $orange;
    }

  }
  .loginPw .el-input__icon.el-icon-loading{display: none;}
</style>



// WEBPACK FOOTER //
// Login.vue?6fdfab11